import $ from "jquery";

const $page = $(".page");
const $body = $(".page__body");
let pageIsTop = true;

$(function () {
  pageScrolled(true);
  $body.on("scroll", pageScrolled);
});

const pageScrolled = (force = false) => {
  if ($body.scrollTop() > 0) {
    pageScrolledHandler(force);
  } else {
    pageTopHandler(force);
  }
};

const pageScrolledHandler = (force = false) => {
  if (pageIsTop === true || force === true) {
    pageIsTop = false;
    $page.addClass("page--scrolled");
  }
};

const pageTopHandler = (force = false) => {
  if (pageIsTop === false || force === true) {
    pageIsTop = true;
    $page.removeClass("page--scrolled");
  }
};
